import { ReactNode } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { useMaintenanceMode } from '@/hooks/useMaintenanceMode';
import { useAdmin } from '@/contexts/AdminContext';
import { Loader2 } from 'lucide-react';

interface MaintenanceGuardProps {
  children: ReactNode;
}

const MaintenanceGuard = ({ children }: MaintenanceGuardProps) => {
  const location = useLocation();
  const { isMaintenanceMode, loading: maintenanceLoading } = useMaintenanceMode();
  const { isAdmin, loading: adminLoading } = useAdmin();

  // Allow admin routes always
  if (location.pathname.startsWith('/admin')) {
    return <>{children}</>;
  }

  // Show loading state while checking (only on initial load)
  if (maintenanceLoading || adminLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  // If maintenance mode is on and user is not admin, redirect to maintenance page
  if (isMaintenanceMode && !isAdmin) {
    return <Navigate to="/maintenance" replace />;
  }

  return <>{children}</>;
};

export default MaintenanceGuard;
